import { SortingDirection } from '../tabs/Positions/components/AlternativeDetail/AlternativeDetail.meta';

export const compareValueStrings = (a, b, sortingDirection) => {
  if (a === '–') {
    return sortingDirection === SortingDirection.Asc ? -1 : 1;
  }

  if (b === '–') {
    return sortingDirection === SortingDirection.Asc ? 1 : -1;
  }

  const parsedA = parseFloat(String(a).replace(/[^0-9.-]+/g, ''));
  const parsedB = parseFloat(String(b).replace(/[^0-9.-]+/g, ''));

  if (Number.isNaN(parsedA) || Number.isNaN(parsedB)) {
    return sortingDirection === SortingDirection.Asc
      ? String(a).localeCompare(String(b))
      : String(b).localeCompare(String(a));
  }

  return sortingDirection === SortingDirection.Asc ? parsedA - parsedB : parsedB - parsedA;
};

export const sortTableRows = (rows, sortingKey, sortingDirection) => {
  const sortedDataRows = rows.map(row => {
    const sortedRows = [...(row.childRows ?? [])].sort((a, b) =>
      compareValueStrings(a.cells[sortingKey].text, b.cells[sortingKey].text, sortingDirection),
    );

    return { ...row, childRows: sortedRows };
  });

  const totalRow = sortedDataRows.pop();

  // Sort groups
  return [
    ...sortedDataRows.sort((a, b) =>
      compareValueStrings(a.cells[sortingKey].text, b.cells[sortingKey].text, sortingDirection),
    ),
    totalRow,
  ];
};

export const sortGainLossTableRows = (rows, sortingKey, sortingDirection) => {
  const sortedDataRows = rows.map(row => {
    const sortedChildRows = [...(row.childRows ?? [])]
      .map(childRow => {
        const sortedLotDetailsRows = [...(childRow.lotDetailsRows ?? [])].sort((a, b) =>
          compareValueStrings(
            a.cells[sortingKey]?.text,
            b.cells[sortingKey]?.text,
            sortingDirection,
          ),
        );

        return {
          ...childRow,
          lotDetailsRows: sortedLotDetailsRows,
        };
      })
      .sort((a, b) =>
        compareValueStrings(a.cells[sortingKey]?.text, b.cells[sortingKey]?.text, sortingDirection),
      );

    return {
      ...row,
      childRows: sortedChildRows,
    };
  });

  return sortedDataRows.sort((a, b) =>
    compareValueStrings(a.cells[sortingKey]?.text, b.cells[sortingKey]?.text, sortingDirection),
  );
};
